import { contactUsConstants } from '../redux-constants'

export function sendEmailContactUs(content) {
    return (dispatch, getState, { firestore }) => {
        dispatch(addContactUsProgress())

        firestore
            .collection('mail')
            .add({
                to: ['support@yupik.eu'],
                template: {
                    data: {
                        name: content.name,
                        surname: content.surname,
                        email: content.email,
                        content: content.emailContent,
                    },
                    name: 'sendEmailContactUs',
                },
            })
            .then(() => {
                dispatch(addContactUsSuccess())
            })
            .catch(error => {
                console.log(error)
                dispatch(addContactUsFailure(error.code))
            })
    }
}

function addContactUsProgress() {
    return {
        type: contactUsConstants.ADD_CONTACTUS_REQUEST,
    }
}

function addContactUsSuccess() {
    return {
        type: contactUsConstants.ADD_CONTACTUS_DONE,
    }
}

function addContactUsFailure(payload) {
    return {
        type: contactUsConstants.ADD_CONTACTUS_FAILURE,
        payload: payload,
    }
}
